// extracted by mini-css-extract-plugin
export default {"wrapper":"AnalyticsPage_wrapper__p1aDp","container":"AnalyticsPage_container__-tREr","heading":"AnalyticsPage_heading__OdMmv"};